export const PlaceType = {
  ADDRESS: "ADDRESS",
  LANDMARK: "LANDMARK",
  AIRPORT: "AIRPORT",
};
